import MyCampaigns from "./MyCampaigns";
import Details from "./Details";
import Campaigns from "./Campaigns";
const pages = {
  Main: Campaigns,
  MyCampaigns,
  Details,
};
export default pages;
